import { ProductsParametersApi } from "@pes-ui/utils/lib/types/api/products-parameters-api";
import { ProductsApi } from "@pes-ui/utils/lib/types/api/products-api";
import { ComparisonBundleProducts } from "@pes-ui/utils/lib/types/api/comparison-bundle-products-api";

export const mapProductsWithCategories = (
    productsResponse: ProductsApi.GetProductsResponse,
    parametersResponse: ProductsParametersApi.GetProductsParametersResponse,
) => {
    const mergedProductsWithPrices = productsResponse.products.map(product => {
        const { commercialReference } = product;
        const productCategories = parametersResponse.items[commercialReference];

        return {
            ...product,
            productCategories,
        };
    });

    return {
        products: mergedProductsWithPrices,
        categories: parametersResponse.sections,
        keyCategories: parametersResponse.keySections,
    };
};

    /*
    * Need to clear categories parameters which have keyProperty === true if keySection exist and
    * is not empty.
    */
export const excludeRedundantCategoryParameters = (data: ReturnType<typeof mapProductsWithCategories>) => {
    if (data.keyCategories.length > 0) {
        const filteredCategories = data.categories.map(category => ({
            ...category,
            parameters: Object.keys(category.parameters).reduce((acc, key: ProductsParametersApi.ParameterTypes) => {
                const param = category.parameters[key];

                if (!param.keyProperty) {
                    acc[key] = param;
                }

                return acc;
            }, {} as ProductsParametersApi.Parameters),
        }));
        return {
            products: data.products,
            keyCategories: data.keyCategories,
            categories: filteredCategories,
        };
    }

    return data;
};

export type MappedProduct = {
    image: ProductsApi.Product['pictureUrl'];
    name: ProductsApi.Product['description'];
    partNumber: ProductsApi.Product['commercialReference'];
    productCategories: Record<ProductsParametersApi.ParameterTypes, ProductsParametersApi.ItemParameter>;
    productId: ProductsApi.Product['commercialReference'];
    url: ProductsApi.Product['pdpUrl'];
    available: ProductsApi.Product['available'];
    bundleProduct?: ComparisonBundleProducts.BundledProductListType;
};

export type MappedProducts = Record<string, MappedProduct>;
